// extracted by mini-css-extract-plugin
module.exports = {"avatar":"theme__avatar--16BoZ","image":"theme__image--114Xy","letter":"theme__letter--1tUYT"};